import { SVGProps } from 'react';

export function ThumbsUpIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.5 6.5H10L10.5 2.5C10.5 2.23478 10.3946 1.98043 10.2071 1.79289C10.0196 1.60536 9.76522 1.5 9.5 1.5C9.23478 1.5 8.98043 1.60536 8.79289 1.79289C8.60536 1.98043 8.5 2.23478 8.5 2.5V2.75L7 6.5H5.5C5.23478 6.5 4.98043 6.60536 4.79289 6.79289C4.60536 6.98043 4.5 7.23478 4.5 7.5V13C4.5 13.2652 4.60536 13.5196 4.79289 13.7071C4.98043 13.8946 5.23478 14 5.5 14H11.5C11.8978 14 12.2794 13.842 12.5607 13.5607C12.842 13.2794 13 12.8978 13 12.5V12L14 7.5C14 7.23478 13.8946 6.98043 13.7071 6.79289C13.5196 6.60536 13.2652 6.5 13 6.5H13.5ZM2.5 7.5H3.5V14H2.5C2.36739 14 2.24021 13.9473 2.14645 13.8536C2.05268 13.7598 2 13.6326 2 13.5V8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
